<template>
  <div id="header">
    <div class="headerWrap">
      <div class="organization"
           @click="goHome">
        <img class="orgLogo"
             :src="logo"
             alt="">
        <p class="orgName"
           v-text="orgName"></p>
      </div>
      <div class="userArea">
        <div class="userInfo">
          <img class="userPhoto"
               :src="userInfo.userImg"
               alt=""
               @error="userImgErr">
          <div class="userDetail">
            <p class="userName"
               v-text="userInfo.userName"></p>
            <p class="userRole"
               v-text="userInfo.userRole"></p>
          </div>
        </div>
        <div class="operate">
          <div class="optItem"
               @click="goHome">
            <v-icon name="home"
                    scale="1.6"></v-icon>
            <p class="iconTitle">首页</p>
          </div>
          <div class="optItem"
               @click="refreshPage">
            <v-icon name="redo"
                    scale="1.3"></v-icon>
            <p class="iconTitle">刷新</p>
          </div>
          <div class="optItem" v-if="ShowQuestion"
               @click="isQuestion = true">
            <v-icon name="question"
                    scale="1.35"></v-icon>
            <p class="iconTitle" >指南</p>
          </div>
          <div class="optItem review" v-if="ShowReview">
            <el-badge :is-dot="qualification || confirmInfo " class="reviewBadge">
            <v-icon name="check"
              scale="1.4"></v-icon>
            </el-badge>
            <p class="iconTitle">审查</p>
            <div class="menu">
              <el-badge :is-dot="confirmInfo">
                <p @click="navTo('/system/confirmInfo')">信息确认</p>
              </el-badge>
              <el-badge :is-dot="qualification">
                <p @click="navTo('/system/qualification')">资质审查</p>
              </el-badge>
              <el-badge :is-dot="peopleAppeal">
                <p @click="navTo('/system/peopleAppealList')">失信人员申诉</p>
              </el-badge>
            </div>
          </div>
          <div class="optItem" v-if="ShowEnvelope"
               @click="toNatice">
              <v-icon name="envelope"
                      scale="1.35"></v-icon>
            <p class="iconTitle"  >通知</p>
            <div class="info_tip" v-show="noticeNum>0">{{noticeNum}}</div>
          </div>
          <div class="optItem setting">
            <el-badge :is-dot="infoRefused">
              <v-icon name="cog"
                      scale="1.4"></v-icon>
            </el-badge>
            <p class="iconTitle">设置</p>
            <div class="menu">
              <p @click="navTo('/setting/person')">登录设置</p>
              <p v-if="ShowDocument" @click="navTo('/system/documents')">文件存档</p>
              <p v-if="ShowLicenseList" @click="navTo('/system/licenseWait')">待生成执照</p>
              <p v-if="ShowBlackList"
                 @click="navTo('/system/blacklist')">失信人员列表</p>
              <p v-if="ShowUnit"
                 @click="navTo('/setting/unit')">机构设置</p>
              <p v-if="ShowVita"
                 @click="navTo('/student/basicSetting')">资料设置</p>
              <p v-if="ShowVita" @click="navTo('/student/getLicenseList')">
                执照领取
              </p>
              <p v-if="ShowTeacherVita"
              @click="navTo('/teacher/vita')">资料设置</p>
              <el-badge :is-dot="infoRefused" v-if="ShowExpStudentVita">
                <p
                   @click="navTo('/expireStudent/basicSetting')">资料设置</p>
              </el-badge>
                <p v-if="ShowExpStudentVita" @click="navTo('/expireStudent/getLicenseList')">
                  执照领取
                </p>
  <!--              <p v-if="ShowExpStudentVita"-->
  <!--                 @click="navTo('/registrationList')">报名入口</p>-->
            </div>
          </div>
          <template v-if="evaFlag">
            <div class="optItem eva"
                 @click="doEvaluation">
              <v-icon name="edit"
                      scale="1.5"></v-icon>
              <p class="iconTitle">调查</p>
              <div class="info_tip" v-show="evaNum>0">{{evaNum|maxNum}}</div>
            </div>
          </template>
          <template v-if="ShowHistory">
            <div class="optItem eva"
              @click="navTo('/student/tran_his')">
              <v-icon name="history"
                scale="1.5"></v-icon>
              <p class="iconTitle">历史</p>
            </div>
          </template>
          <div class="optItem"
               @click="loginOut">
            <v-icon name="power-off"
                    scale="1.35"></v-icon>
            <p class="iconTitle">退出</p>
          </div>
        </div>
      </div>
    </div>
    <yioks-tips :showTips.sync="isLoginOut"
                :tips="'您确定退出登录吗?'"
                :dw="'420px'"
                @hideTips="hideLoginOut"></yioks-tips>
    <el-dialog custom-class="system_manager_dialog"
               :visible.sync="isQuestion"
               :title="questionInfo.orgQuestion"
               :close-on-click-modal="false"
               width="600px">
      <div class="qusetion_manager_guide">
        <video controls autoplay :poster="Poster">
          <source :src="questionInfo.mp4Question" type="video/mp4">
          <source :src="questionInfo.webmQuestion" type="video/webm">
          浏览器不支持HTML5的视频播放功能
        </video>
        <!--<div class="manager_ppt">
          <a :href="questionInfo.pptQuestion" download><strong>下载【{{questionInfo.orgQuestion}}.pptx】</strong></a>
        </div>-->
      </div>
      <div class="btns">
        <div class="btn save"
             @click="isQuestion = false">关闭窗口
        </div>
      </div>
    </el-dialog>
    <yioks-tips :showTips.sync="warnDialog"
                :tips="'您填写的信息将不会保存<br/>确定离开此页面吗?'"
                :dw="'420px'"
                @hideTips="hideWarnDialog"></yioks-tips>
  </div>
</template>

<script>
  /* components/Header.vue */
  import "vue-awesome/icons/home";
  import "vue-awesome/icons/redo";
  import "vue-awesome/icons/cog";
  import "vue-awesome/icons/power-off";
  import "vue-awesome/icons/edit";
  import "vue-awesome/icons/question";
  import "vue-awesome/icons/history";
  import "vue-awesome/icons/envelope";
  import "vue-awesome/icons/check";

  import Logo from "@/assets/images/footballAssociation.png";
  import Person from "@/assets/images/person.png";
  import Poster from "@/assets/images/video_bg.jpg";
  import {storageData} from "@/assets/js/storage";
  import {roleType} from "@/assets/js/status";
  import {routerJump, evaluationJump} from "@/assets/js/yioksRouter";

  const HOST = process.env.VUE_APP_URL;
  import {mapMutations, mapGetters} from "vuex";
  import {signOut} from "@/api/common/api";

  export default {
    name: "Header",
    data() {
      const path = ["create_class",'create_high_class', 'create_high_class_second',"edit_class", "upload_score", "edit_score", "class_report", "/student/basicSetting", "/expireStudent/basicSetting",'student/qualificationSetting','/expireStudent/qualificationSetting', "create_tutorial", "edit_tutorial", "/notice/create","/expireStudent/vita", "/student/vita", "/teacher/vita","register_vita","register_file"];
      return {
        path,
        isLoginOut: false,
        ShowQuestion: false,
        ShowReview: false,
        ShowEnvelope: false,
        isQuestion: false,
        ShowBlackList:false,
        ShowLicenseList:false,
        ShowDocument:false,
        orgName: "中国足球协会信息化平台教练员培训管理系统",
        evaFlag: false,
        ShowUnit: false,
        ShowVita: false,
        ShowExpStudentVita:false,
        ShowTeacherVita: false,
        ShowHistory: false,
        userPhoto: Person,
        logo: Logo,
        Poster,
        warnDialog: false,
        warnOption: {
          opt: "",
          path: ""
        },
      }
    },
    computed: {
      noticeNum() {
        return this.$store.state.stateNoticeNum
      },
      confirmInfo(){
        return this.$store.state.confirmInfo
      },
      infoRefused(){
        return this.$store.state.infoRefused
      },
      peopleAppeal(){
        return this.$store.state.peopleAppeal
      },
      qualification(){
        return this.$store.state.qualification
      },
      userInfo: {
        get() {
          const info = this.$store.state.userInfo;
          // console.log(info.profile_picture);
          const imgUrl = info.profile_picture === '' ? this.userPhoto : (info.profile_picture !== this.userPhoto ? HOST + info.profile_picture : this.userPhoto);
          // console.log(imgUrl);
          return {
            userName: info.name,
            userRole: roleType(info.member_type),
            userImg: imgUrl
          };
        },
      },
      questionInfo: {
        get() {
          const info = this.$store.state.userInfo;
          return {
            orgQuestion: "使用说明-" + roleType(info.member_type) + "端",
            mp4Question: "http://rescdn.yioks.cn/zuxie/" + info.member_type + ".mp4",
            webmQuestion: "http://rescdn.yioks.cn/zuxie/" + info.member_type + ".webm",
            pptQuestion: "http://rescdn.yioks.cn/zuxie/使用说明-" + roleType(info.member_type) + "端.pptx"
          };
        },
      },
      evaNum: {
        get() {
          return this.$store.state.evaNum;
        },
      },
    },
    filters: {
      maxNum(num) {
        return num >= 100 ? "99+" : num;
      },
    },
    components: {
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
    },
    created() {
      this.showHeaderInfo();
    },
    methods: {
      ...mapMutations(["clearHeartBeat"]),
      showHeaderInfo() {
        const userInfo = storageData.getUserInfo();
        (userInfo.member_type === "organ" || userInfo.member_type === "teacher") && (this.evaFlag = true);
        (userInfo.member_type === "student" ) && (this.ShowQuestion = true);
        (userInfo.member_type === "system" ||  userInfo.member_type === "super") && (this.ShowReview = true);
        (userInfo.member_type !== "registration" & userInfo.member_type !== "expireStudent" ) && (this.ShowEnvelope = true);
        this.ShowUnit = userInfo.member_type === 'organ';
        this.ShowVita = userInfo.member_type === 'student';
        this.ShowTeacherVita = userInfo.member_type === 'teacher';
        this.ShowExpStudentVita = userInfo.member_type === 'expireStudent';
        this.ShowBlackList=userInfo.member_type==='system' || userInfo.member_type==='super'
        this.ShowLicenseList=userInfo.member_type==='system' || userInfo.member_type==='super'
        this.ShowDocument=userInfo.member_type==='system' || userInfo.member_type==='super'
        this.ShowHistory = userInfo.member_type === 'student' && userInfo.class_level !== 'D';
      },
      checkPath() {
        let flag = true;
        this.path.map((item) => {
          if (this.$route.path.includes(item)) {
            flag = false;
            this.warnDialog = true;
          }
        });
        return flag;
      },
      hideWarnDialog(bool, flag) {
        this.warnDialog = bool;
        if (flag) {
          this.warnOption.opt === "router"
            ? this.$router.push(this.warnOption.path)
            : window.location.reload(true);
        }
      },
      goHome() {
        const path = routerJump();
        if (path === this.$route.path) return false;
        const flag = this.checkPath();
        if (flag) {
          this.$router.push(path);
        } else {
          this.$set(this.warnOption, "opt", "router");
          this.$set(this.warnOption, "path", path);
        }
      },
      refreshPage() {
        const flag = this.checkPath();
        if (flag) {
          window.location.reload(true);
        } else {
          this.$set(this.warnOption, "opt", "refresh");
        }
      },
      navTo(path) {
        if(path === this.$route.path) return;
        const flag = this.checkPath();
        if (flag) {
          this.$router.push(path);
        } else {
          this.$set(this.warnOption, "opt", "router");
          this.$set(this.warnOption, "path", path);
        }
      },
      doEvaluation() {
        const flag = this.checkPath();
        const path = evaluationJump();
        if (flag) {
          this.$router.push({path, query: {}});
        } else {
          this.$set(this.warnOption, "opt", "router");
          this.$set(this.warnOption, "path", path);
        }
      },
      toNatice() {
        const userInfo = storageData.getUserInfo();
        const path = new Set(['super','system']).has(userInfo.member_type) ? '/notice/my_send' : '/notice/my_get';

        if(this.$router.path === path) return;
        const flag = this.checkPath();
        if (flag) {
          this.$router.push({path, query: {}});
        } else {
          this.$set(this.warnOption, "opt", "router");
          this.$set(this.warnOption, "path", path);
        }
      },
      loginOut() {
        this.isLoginOut = true;
      },
      hideLoginOut(bool, flag) {
        this.isLoginOut = bool;
        if (flag) {
          this.clearHeartBeat(); // 清除心跳
          const token = storageData.getToken();
          const userType = storageData.getUserType();
          // 退出登录接口
          signOut({}, token, userType)
            .catch((err) => {
              console.error(err);
            });
          storageData.clearUserInfo();
          storageData.clearToken();
          storageData.clearUserType();
          this.$router.replace({
            path: "/login",
            query: {}
          });
        }
      },
      userImgErr() {
        this.$store.commit("updateUserImg", this.userPhoto);
      },
    }
  };
</script>
<style lang="stylus">
  #header {
    .loginOut {
      margin-top: calc(50vh - 150px) !important;
      border-radius: 10px;
      .el-dialog__body {
        padding: 0;
      }
    }
    .el-badge__content.is-dot{
      right 0
    }
  }
</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  #header {
    display: flex;
    justify-content: center;
    height: 90px;
    background: $color_white;
    user-select: none;
  }

  .headerWrap {
    display: flex;
    justify-content: space-between;
    width: 1024px;
  }

  .organization {
    display: flex;
    align-items: center;
    flex none
    &:hover {
      cursor: pointer;
    }

    .orgLogo {
      width: 55px;
      height: 55px;
      margin: 0 10px;
    }

    .orgName {
      color: #3e3e3e;
      font-size: $font_size_big;
    }
  }

  .userArea {
    display: flex;
  }

  .userInfo {
    display: flex;
    align-items: center;

    .userPhoto {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: 1px solid $color_suc;
    }

    .userDetail {
      margin: 0 15px 0 10px;
      .userName {
        font-size: $font_size_big;
        color: $color_suc;
        // word-break break-word
        word-break break-all
        word-wrap break-word
      }
      .userRole {
        font-size: $font_size_medium;
        color: #333;
      }
    }
  }

  .operate {
    display: flex;

    .optItem {
      position: relative;
      width: 53px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .info_tip {
        width: 20px;
        height: @width;
        position: absolute;
        top: 20px;
        right: 0;
        border-radius: 50%;
        color: $color_white;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        background-color: $color_err;
      }
      &:hover {
        background-color: $color_suc;
        .info_tip {
          top: 10px;
        }
        .fa-icon {
          color: $color_white;
        }
        .iconTitle {
          display: flex;
          margin-top: 3px;
          font-size: $font_size_medium;
          color: $color_white;
        }
      }
      .fa-icon {
        color: $color_suc;
      }
      .iconTitle {
        display: none;
      }
      .menu {
        display: none;
        width: 112px;
        z-index 111
        padding: 5px 0;
        position: absolute;
        left: -26px;
        top: 70px;
        text-align: center;
        font-size: $font_size_medium;
        line-height: 28px;
        color: $color_white;
        background-color: $color_suc;
      }
    }
    .eva {
      .evaTips {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 20px;
        right: 0;
        border-radius: 50%;
        color: $color_white;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        background-color: $color_err;
      }
      &:hover {
        .evaTips {
          top: 10px;
        }
      }
    }
    .review:hover {
      .menu {
        display: block;
      }
    }
    .setting:hover {
      .menu {
        display: block;
      }
    }
  }

  .qusetion_manager_guide {
    text-align: center;
    padding: 0 20px;
    video {
      width: 100%;
      height: 100%;
    }
    .manager_ppt {
      padding: 15px;
    }
  }
</style>
